import React, { useState, useEffect } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";

function StudentcorrectionXI() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/intermediate-admin");
    }
  }, []);

  // ---------------- STATE ----------------
  const [formData, setFormData] = useState({
    passingYear: "2025",
    session: "",
    candidateId: "",
  });

  // ---------------- HANDLE CHANGE ----------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ---------------- SEARCH ----------------
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!formData.candidateId.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Candidate ID",
        text: "Please enter Candidate ID",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchDataStudentRegistrationCandidateID_CL11`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            candidatE_ID: formData.candidateId,
          }),
        },
      );

      const data = await response.json();

      if (response.ok && data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/intermediate-demographic-details-update-page-xi", {
          state: { studentData: data?.data?.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with this Candidate ID.",
        });
      }
    } catch (err) {
      console.error("API Error:", err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong.",
      });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              {/* HEADER */}
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" />
                      Student Demographic Details Correction for Class XI
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() =>
                            navigate("/intermediate-admin-dashboard")
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: "5px" }}
                          ></i>
                          Home
                        </a>
                      </li>

                      <li className="active">
                        Student Correction for Class XI
                      </li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* SEARCH SECTION */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-center">
                      {/* Candidate ID Input */}
                      <div className="col-md-3">
                        <label className="mb-1">Candidate ID</label>

                        <input
                          className="form-control form-control-xs mt-2"
                          name="candidateId"
                          value={formData.candidateId}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                          placeholder="Enter Candidate ID"
                          inputMode="numeric"
                          maxLength={15}
                        />
                      </div>

                      {/* Search Button */}
                      <div className="col-md-2">
                        <button
                          className="btn btn-success"
                          style={{ marginTop: "28px" }}
                          onClick={handleSearch}
                        >
                          <i className="fa fa-search"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentcorrectionXI;
